<script>
import Page from '@/components/elements/Page';
import PageIntro from '@/components/elements/PageIntro';
import UserConsent from './userConsentAanmelding';
import CcButton from '@/components/elements/CcButton';
import ErrorLabel from '@/components/elements/ErrorLabel';

export default {
    name: 'HomeAanmelding',
    components: {
        ErrorLabel,
        CcButton,
        Page,
        PageIntro,
        UserConsent
    },
    data() {
        return {
            clickedNext: false
        }
    },
    computed: {
        consent() {
            return this.$store.state.userConsent;
        }
    },
    methods: {
        gotoHome() {
            this.$router.push({ name: 'Home' })
        },
        next() {
            this.clickedNext = true;
            if (this.consent) {
                this.$router.push({ name: 'signupInformation' });
            }
        },
        setUserConsent(value) {
            this.$store.commit('setUserConsent', value);
        }
    },
    mounted() {
        this.$store.state.userConsent = false;
        this.$store.state.aanMeldingVerify = false;
    }
}
</script>

<template>
    <Page
        class="home"
        @back="gotoHome">
        <div class="section">
            <PageIntro
                :head="$t('views.HomeAanmelding.pageHeader')"
                :intro="$t('views.HomeAanmelding.pageIntro')"/>
            <div class="section-block">
                <h2 class="screen-reader-text">{{ $t('views.home.userConsentHeader') }}</h2>
                <UserConsent
                    @update="setUserConsent"
                    :consent="consent"
                    :label="$t('views.home.userConsentText')"/>
                <ErrorLabel
                    v-if="clickedNext && !consent"
                    :label="$t('views.home.noConsentError')"/>
            </div>
            <div class="section-block">
                <CcButton
                    @select="next()"
                    :label="$t('next')"/>
            </div>
        </div>
    </Page>
</template>

<style lang="scss">
@import "@/styles/variables/index";

.home {

    .home__section {
        margin-bottom: $length-l;
    }

    .UserConsent {
        margin: $grid-x6 0 $length-s 0;
    }

    .ErrorLabel {
        margin-bottom: $length-s;
    }
}
</style>
